import { render, staticRenderFns } from "./c2c.vue?vue&type=template&id=4885fb42&scoped=true&"
import script from "./c2c.vue?vue&type=script&lang=js&"
export * from "./c2c.vue?vue&type=script&lang=js&"
import style0 from "./c2c.vue?vue&type=style&index=0&id=4885fb42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4885fb42",
  null
  
)

export default component.exports